export default {
  // apiUrl: 'http://localhost:9090/redseat/',
  apiUrl: 'https://api.courierdepotja.com/',
 s3Url: 'https://redseat-pdf.s3.amazonaws.com/',
 company: 10,
};
